import React from "react";
import { useTranslation } from "react-i18next";
import { Col, Nav, Offcanvas, Row } from "react-bootstrap";
import { NavLinkWithLocale } from "../index";
import style from "./HeaderBar.module.css";

const UnloggedHamburgerMenu = ({ handleNavLinkClick }) => {
  const { t } = useTranslation();
  return (
    <Offcanvas.Body>
      <Nav>
        <Row className="flex-column" style={{ height: "65vh" }}>
          <Col className="d-flex flex-column">
            <NavLinkWithLocale
              onClick={handleNavLinkClick}
              className={`${style.mobileUnloggedLinks}`}
              to="/product"
            >
              {t("Plans & Pricing")}
            </NavLinkWithLocale>
            <NavLinkWithLocale
              onClick={handleNavLinkClick}
              className={style.mobileUnloggedLinks}
              to="/colormatch"
            >
              {t("Match Colors")}
            </NavLinkWithLocale>
            <NavLinkWithLocale
              onClick={handleNavLinkClick}
              className={`${style.mobileUnloggedLinks}`}
              to="/search"
            >
              {t("Search Balloons")}
            </NavLinkWithLocale>
          </Col>
          <Col className="flex-grow-0">
            <NavLinkWithLocale
              onClick={handleNavLinkClick}
              className={style.logIn}
              to="/login"
            >
              {t("Log In")}
            </NavLinkWithLocale>
          </Col>
          <Col className="flex-grow-0 mt-4">
            <NavLinkWithLocale
              onClick={handleNavLinkClick}
              className={style.signUp}
              to="/createAccount"
            >
              {t("Sign Up")}
            </NavLinkWithLocale>
          </Col>
        </Row>
      </Nav>
    </Offcanvas.Body>
  );
};

export default UnloggedHamburgerMenu;
